import {
  imu1AdSlotSizesInfinteScroll,
  pubPageAdTargeting,
} from "@config/AdsConstants";
import CompanionAdvertisement from "@elements/Advertisement/CompanionAdvertisement";
import { GoogleAdsSlotFactory } from "@elements/Advertisement/helpers";
import {
  AdTargetingType,
  AdvertisementTypeEnum,
  PageAdTargetValue,
} from "@typings/Ads.d";

export function Imu1CompanionAdsInfiniteScroll({
  sectionName,
  index,
  pageAdTargetType,
  gsChannels,
}: {
  sectionName?: string;
  index: number;
  pageAdTargetType: PageAdTargetValue;
  gsChannels?: string[];
}) {
  const pageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;

  let overrideLb1Slot = imu1AdSlotSizesInfinteScroll["desktop"];
  if (typeof window !== "undefined" && screen.width < 767) {
    overrideLb1Slot = imu1AdSlotSizesInfinteScroll["mobile"];
  }

  return (
    <div className="w-full">
      <CompanionAdvertisement
        rootClassName="textAlignWebkitCenter"
        companionAdUnitProps={{
          type: AdvertisementTypeEnum.IMU1,
          slot: GoogleAdsSlotFactory.imu1(sectionName),
          id: `dfp-ad-imu1-${index}`,
          rootClassName: "m-0",
          adSlotSize: overrideLb1Slot,
          pageNumber: index.toString(),
          pubAdTargeting: [pageAdTarget],
          gsChannels,
        }}
      />
    </div>
  );
}
